import { Form, Input,  Button, Layout, Row, Col,notification,ConfigProvider } from 'antd';
import { UserOutlined,  EyeInvisibleOutlined, EyeTwoTone, LockOutlined} from '@ant-design/icons';
import React, {  useState } from "react";
import cabezal from '../Cabezal.jpg'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import PropTypes from 'prop-types';
import {IP} from '../components/utils';
import Foot from "../components/Footer" 

async function loginUser(username,password) {
  const response_user= await fetch(IP + `api/casa/usuario/${username}/`,{//Get User by username
    method: "get",
    credentials: "same-origin",
  });
  const json_user = await response_user.json();
  if(json_user['detail']){//If does not exist, it returs detail key
    return notification.error({
      message:'Error',
      description:'Hubo un error, por favor revise su nombre de usuario y contraseña',})
  }
  if(!json_user.grupos.includes('casaAdmin')){//Check if it is admin of this award
    return notification.error({
      message:'Error',
      description:'Usted no es un administrador'})
  }

  const data= new FormData()
  data.append('username',username)
  data.append('password',password)
  return axios.post(IP + 'api/login/', data).then(data =>{ //If user exists, send password. If correct, it logs, otherwise it shows an error
    localStorage.setItem('UserId', json_user.id)//Save UserId and Role in storage for fastest check in the future
    localStorage.setItem('Admin', 'casa')
    return data.data
  }).catch(error=>
    notification.error({
      message:'Error',
      description:'Hubo un error, por favor revise su nombre de usuario y contraseña',
    }))
}

export default function Login({ setToken }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const handleSubmit = async(form) => {
    const token = await loginUser(username,password).catch(error=>console.log(error))
    var userId = localStorage.getItem("UserId")
    const data_log= new FormData()
    data_log.append('usuario',userId)
    data_log.append('accion',"Ingreso al sistema")
  
    await axios.post(IP + 'api/casa/logs/', data_log)
    setToken(token);
    localStorage.setItem('User', username)
  }
  const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
  
  const { Content } = Layout;
  return (
    <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <Row>
              <Col><NavLink to="/casa"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
            </Row>
            <div className="login-wrapper">
              <Content>
                <Form {...formItemLayout} onFinish={handleSubmit} >
                  <Row justify="center" align="middle">
                    <Col  xs={{span:22, offset:2 }}sm={{span:24, offset:8 }} >
                      <Form.Item label="Usuario">
                        <Input
                            placeholder="Introduzca su usuario"
                            prefix={<UserOutlined className="site-form-item-icon" />}
                            onChange={e => setUserName(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" align="middle">
                    <Col   xs={{span:22, offset:2 }}sm={{span:24, offset:8 }}>
                      <Form.Item label="Contraseña">
                        <Input.Password
                            placeholder="Introduzca su contraseña"
                            prefix={ <LockOutlined />}
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            onChange={e => setPassword(e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row justify="center" align="middle">
                    <Col   xs={{span:22, offset:1 }}sm={{span:24, offset:22 }}>
                      <Form.Item >
                        <Button htmlType="submit">Login</Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Content>
            </div>
        </Layout>
      </ConfigProvider>
      </div>
      <Foot />
  </div>);
}
Login.propTypes = {
  setToken: PropTypes.func.isRequired
};


